import React, { useState, useEffect } from 'react';
import { Tag, Space, ConfigProvider } from 'antd';
import { GetAllItensDoProcesso, DeleteItemProcesso } from '@services/ItensProcesso/Index.jsx';
import { CustomLoader } from '@components/UI/CustomLoader/Index.jsx';
import { EditOptionComp } from '@components/UI/EditOption/Index.jsx';
import { DeleteOptionComp } from '@components/UI/DeleteOption/Index.jsx';
import FilterView from '@components/UI/FilterView/Index.jsx';
import { StyledTable } from '@styles/datatables/datatable-antd.js';
import ptBR from 'antd/es/locale/pt_BR';
import TextBlock from '@components/UI/TextBlock/Index..jsx';
import EtapaProcesso from '@components/UI/EtapaProcesso/Index';
import { flgStatusOptions } from '@enums/FlgStatus/Index';
import customStylesSelect from '@styles/react-select';
import Select from 'react-select';
import { etapaProcessoOptions } from '@enums/EtapasProcesso/Index';

const GridItensProcesso = ({ state, setData, openModal, setSelectedRow, onDelete }) => {
  const [filters, setFilters] = useState({
    codigo: '',
    nomeItem: '',
    etapaProcesso: '',
    flgStatus: '',
  });
  const filterLabels = {
    codigo: 'CÓDIGO',
    nomeItem: 'ITEM DO PROCESSO',
    etapaProcesso: 'ETAPA PROCESSO',
    flgStatus: 'STATUS',
  };
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchData = async (currentPage, currentRowsPerPage, filters = {}) => {
    setLoading(true);
    try {
      const response = await GetAllItensDoProcesso(currentPage, currentRowsPerPage, filters);
      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page, rowsPerPage, filters);
  }, [page, rowsPerPage, filters]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
  };

  const columns = [
    {
      title: 'CÓDIGO',
      dataIndex: 'codigo',
      key: 'codigo',
      sorter: (a, b) => a.codigo - b.codigo,
      width: '15%',
    },
    {
      title: 'ETAPA',
      dataIndex: 'etapaProcesso',
      key: 'etapaProcesso',
      width: '20%',
      sorter: (a, b) => a.etapaProcesso.localeCompare(b.etapaProcesso),
      render: (_, record) => <EtapaProcesso etapaProcesso={record.etapaProcesso} />
    },
    {
      title: 'ITEM DO PROCESSO',
      dataIndex: 'nomeItem',
      key: 'nomeItem',
      width: '30%',
      sorter: (a, b) => a.nomeItem.localeCompare(b.nomeItem),
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'STATUS',
      dataIndex: 'flgStatus',
      key: 'flgStatus',
      sorter: (a, b) => a.flgStatus - b.flgStatus, // Ordenação
      render: (flgStatus) => (
        <Tag color={(flgStatus) === true ? 'green' : 'red'}>
          {(flgStatus) === true ? 'ATIVO' : 'INATIVO'}
        </Tag>
      ),
      width: '15%',
    },
    {
      title: 'AÇÕES',
      key: 'actions',
      render: (text, row) => (
        <Space size="middle">
          <EditOptionComp
            row={row}
            setSelectedRow={setSelectedRow}
            openModal={openModal}
          />
          <DeleteOptionComp
            row={row}
            deleteFunction={DeleteItemProcesso}
            onDelete={onDelete}
            itemNameKey={"nomeItem"}
          />
        </Space>
      ),
      width: '10%',
    },
  ];

  const customFieldComponents = {
    flgStatus: ({ value, onChange }) => (
      <Select
        value={flgStatusOptions.find(opt => opt.value === value)}
        onChange={option => onChange(option?.value ?? "")}
        placeholder={"Selecione um status"}
        options={flgStatusOptions}
        isClearable
        isSearchable={false}
        styles={customStylesSelect}
      />
    ),
    etapaProcesso: ({ value, onChange }) => (
      <Select
        value={etapaProcessoOptions.find(opt => opt.value === value)}
        onChange={option => onChange(option?.value ?? "")}
        placeholder={"Selecione uma etapa do processo"}
        options={etapaProcessoOptions}
        isClearable
        isSearchable={false}
        styles={customStylesSelect}
      />
    ),
  };

  return (
    <div className='px-4'>
      <FilterView
        filters={filters}
        setFilters={setFilters}
        filterLabels={filterLabels}
        customFieldComponents={customFieldComponents}
      />

      <div className='mt-3 mb-3'>
        <h1>Lista de Itens do Processo Registrados</h1>
      </div>

      <ConfigProvider locale={ptBR}>
        <StyledTable
          rowKey={"id"}
          columns={columns}
          dataSource={state.data}
          loading={{
            spinning: loading,
            indicator: <CustomLoader />, // Spinner personalizado
          }}
          pagination={{
            current: page,
            pageSize: rowsPerPage,
            total: state.totalRows,
            onChange: handlePageChange,
            showSizeChanger: true,
            onShowSizeChange: handlePageChange,
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`, // Exibe o total de registros
          }}
          scroll={{ y: '20rem', x: 'max-content' }}
          locale={{ emptyText: <h2 className='m-3'>Nenhum registro disponível para exibição.</h2> }}
        />
      </ConfigProvider>
    </div>
  );
};

export default GridItensProcesso;